module.exports = __webpack_public_path__ + "img/item23.cf4030f5.png";